import type { SettingsComponentProps } from './SettingsComponent';

export const SettingsComponent = {
    MountAsync: async (target: HTMLElement, props: SettingsComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { SettingsComponent } = await import('./SettingsComponent');
        return await mountReactComponentAsync(target, SettingsComponent, props);
    }
};
